export default __webpack_public_path__ + "static/media/Incase.dc897504.svg";